'use client';

import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import { useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { useUser } from '@/app_lib/providers/UserProvider';

export const FreeStarScript = () => {
  const { pageAdConfig, arcSpanPageConfig } = useAdContext();
  const { personalizedAds } = useUser();
  const lastAppliedNonPersonalizedAds = useRef<boolean | null>(null);
  const arcSpanConfig = useMemo(
    () => ({
      ...pageAdConfig,
      ...arcSpanPageConfig,
    }),
    [pageAdConfig, arcSpanPageConfig],
  );

  // useLayoutEffect runs before paint so ad targeting is set as soon as config is available
  useLayoutEffect(() => {
    for (const [key, value] of Object.entries(arcSpanConfig)) {
      if (value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        FreestarAdSlot.setPageTargeting(key, value);
      }
    }
  }, [arcSpanConfig]);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.freestar?.queue) {
      return;
    }
    const nonPersonalizedAds = personalizedAds !== true;
    if (lastAppliedNonPersonalizedAds.current === nonPersonalizedAds) {
      return;
    }
    lastAppliedNonPersonalizedAds.current = nonPersonalizedAds;
    window.freestar.queue.push(() => {
      if (window.googletag?.pubads) {
        window.googletag.pubads().setPrivacySettings({
          nonPersonalizedAds,
        });
      }
    });
  }, [personalizedAds]);

  return <></>;
};
